import React, {useEffect, useState} from 'react';
import classNames from "classnames";
import styles from "./interstitial-ad.module.scss";
import {InterstitialAdCloseButton} from "./interstitial-ad.close-button";
import {GoogleAdManager} from "../../managers/ads/ad.google.manager";
import useAdUnit from "../../../infrastructure/hooks/ads/useAdUnit";

export const InterstitialAdContent = ({controller, onCloseClick, unitConfig, isFilled}) => {
  const googleAdManager = controller.props.ioc.getInstance(GoogleAdManager);
  const [closeButtonVisible, setCloseButtonVisible] = useState(false);

  useEffect(() => {
    isFilled && setTimeout(() => setCloseButtonVisible(true), 1000);
  }, [isFilled]);

  useAdUnit(googleAdManager, unitConfig);

  return (
    <div className={classNames(styles.ad_container)}>
      <div id={unitConfig.slotId} className={classNames(styles.ad)}/>
      {closeButtonVisible ? <InterstitialAdCloseButton onClose={() => onCloseClick()}/> : null}
    </div>
  )
};